import { FC } from "react";

export const SectionHeader: FC<{ title: string }> = ({ title }) => (
  <h3 className="text-lg leading-6 font-medium text-gray-900 mb-6 sm:mb-2 pt-10">
    {title}
  </h3>
);
